module.exports = __webpack_public_path__ + "static/img/default.7fc20ea9.png";